import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import {
  Button,
  DateTime,
  Icon,
  Table,
  TableCell,
  Text
} from 'components/common/Elements/Elements';

import { statusColor } from 'utils/common';

import classes from './RulesTable.module.scss';

const TableRow = ({
  company,
  tableConf,
  row,
  mouseEnter,
  idsOpenRow,
  handleOpenRow
}) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        const idForOpen = company.ruleId;
        return (
          <Fragment key={`${field}-${company.ruleId}}`}>
            {show && field === 'priority' && (
              <TableCell cellProps={cellProps}>
                {
                  <Button
                    className={cn(
                      classes.button,
                      classes.button_wrap,
                      !idsOpenRow.find(item => item === company.ruleId) &&
                        classes.button_open
                    )}
                    onClick={() => {
                      handleOpenRow(idForOpen);
                    }}
                    aria-label="Open/close"
                  >
                    <Icon
                      size="16px"
                      icon="arrow"
                      className={
                        idsOpenRow.find(item => item === company.ruleId)
                          ? classes.iconDown
                          : classes.iconUp
                      }
                    />
                  </Button>
                }
                <Text type="s"> {company.priority}</Text>
              </TableCell>
            )}
            {show && field === 'status' && (
              <TableCell cellProps={cellProps}>
                <div className={classes.notifWrap}>
                  <div
                    className={classes.marker}
                    style={{
                      backgroundColor: statusColor(company.status.toLowerCase())
                    }}
                  />
                  <Text className={classes.notif} weight="m">
                    {company.status}
                  </Text>
                </div>
              </TableCell>
            )}
            {show && field === 'action' && (
              <TableCell cellProps={cellProps}>
                <div className={classes.notifWrap}>
                  <div
                    className={classes.marker}
                    style={{
                      backgroundColor: statusColor(company.action.toLowerCase())
                    }}
                  />
                  <Text className={classes.notif} weight="m">
                    {company.action}
                  </Text>
                </div>
              </TableCell>
            )}
            {show && field === 'networkPolicyId' && (
              <TableCell cellProps={cellProps} isId>
                {company.networkPolicyId}
              </TableCell>
            )}
            {show && field === 'ruleName' && (
              <TableCell cellProps={cellProps}>{company.ruleName}</TableCell>
            )}
            {show && field === 'logEnabled' && (
              <TableCell cellProps={cellProps}>{company.logEnabled}</TableCell>
            )}
            {show && field === 'createdAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.createdAt} time />
              </TableCell>
            )}
            {show && field === 'updateAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.updateAt} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func,
  idsOpenRow: PropTypes.array,
  handleOpenRow: PropTypes.func.isRequired
};

export default TableRow;
